function chooseImage() {
  return new Promise(resolve => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.capture = 'user';
    input.onchange = () => {
      const file = input.files && input.files[0];
      if (!file) return resolve({didCancel: true});
      resolve({
        assets: [{
          uri: URL.createObjectURL(file),
          fileName: file.name,
          type: file.type,
          fileSize: file.size,
        }],
      });
    };
    input.click();
  });
}

export const launchCamera = chooseImage;
export const launchImageLibrary = chooseImage;
